import { join } from "ramda";
import { canUseLocalDevelopmentConfig } from "src/constants";
import { queryPresets } from "src/queries/base";
import { useReactQuery } from "src/queries/useQuery";
import { GQLQueryBuilder } from "src/services/grapqlQueries/queryBuilder";
import { useRequestGQLQuery } from "src/services/grapqlQueries/useGraphQLQuery";
import { isNotEmpty, returnIsNotEmptyOrTrue } from "src/utilities/hasValue";


/**
 * this method is used to useQuery with one time fetch to query cache with given key indentifier (queries)
*/

export const useOneTimeFetch = (
    queryBuilder: GQLQueryBuilder,
    queryNames?: string[],
    queryIdentifierKeys?: any,
    developmentQueryFn?: any,
) => {
    const keyes: any = isNotEmpty(queryNames) ? queryNames : queryBuilder.getQueryNames();
    const { query, variables } = isNotEmpty(queryNames) ? queryBuilder.getQueryByName(queryNames || []) : queryBuilder.getQuery()
    const queryIdentifier = isNotEmpty(queryIdentifierKeys) ? queryIdentifierKeys : [join(':', keyes), variables]
    return useReactQuery(
        queryIdentifier,
        returnIsNotEmptyOrTrue(
            canUseLocalDevelopmentConfig && isNotEmpty(developmentQueryFn),
            () => developmentQueryFn(),
            () => useRequestGQLQuery(query, variables)
        ),
        {
            ...queryPresets.oneTimeFetch,
            enabled: true,
            retry: true,
        });
};
